// Thin helpers shared by the Task Drafts feature (CU-123yxuaptmf). Reading
// and discarding drafts goes straight through queries/taskDrafts.js's React
// Query hooks from the components that render them; this file only holds
// the bits needed outside a component's render.

import { saveTaskDraft } from "../queries/taskDrafts";

export const UNFINISHED_TASKS_KEY = "unfinished-tasks";
export const UNFINISHED_TASKS_TITLE = "Unfinished Tasks";

// Strip HTML from the contentEditable prompt so a plain-text length/emptiness
// check never sees markup. A resumed draft's HTML comes back from the
// server, so it's untrusted — DOMParser builds an inert document (per spec,
// it never fetches resources or runs scripts/handlers) instead of assigning
// to a live element's innerHTML, where e.g. an <img src=x onerror=...> would
// still fire even on a detached node.
export function plainText(html) {
  if (!html) return "";
  if (typeof DOMParser !== "undefined") {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return (doc.body?.textContent || "").replace(/\s+/g, " ").trim();
  }
  return String(html).replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

// A brand-new Task that was being built (real title/body already typed in)
// and then abandoned without saving. locationId is required — without it
// there's no account to attach the draft to, so the capture is skipped.
export function saveUnfinishedTaskDraft({ locationId, userId, title, prompt }, queryClient) {
  const cleanTitle = (title || "").trim();
  const cleanPrompt = (prompt || "").trim();
  if (!locationId) return Promise.resolve();
  if (!cleanTitle && !cleanPrompt) return Promise.resolve();

  return saveTaskDraft(
    {
      locationId,
      userId,
      title: cleanTitle,
      prompt: cleanPrompt || cleanTitle,
      parentKey: UNFINISHED_TASKS_KEY,
      parentTitle: UNFINISHED_TASKS_TITLE,
    },
    queryClient,
  ).catch(() => {
    // Best-effort: a failed capture (offline, server hiccup, or the tab
    // closing mid-request) just means no draft — never block navigation.
  });
}
